import axios from 'axios';
import { settings } from '@/plugins/settings';
import { ILockerNetworkHealth } from '@/model/shortInterfaces';

export const lockerService = {
  exportLockers(filters: any = {}): Promise<any[]> {
    return axios({
      url: settings.endpoint + 'lockers/export',
      method: 'GET',
      params: filters,
    }).then((response: any) => {
      if (response && response.data && Array.isArray(response.data.data)) return response.data.data;
      if (response && Array.isArray(response.data)) return response.data;
      return [];
    });
  },

  fetchInstallFilterOptions(): Promise<{ statuses: string[], os_versions: string[] }> {
    return axios({
      url: settings.endpoint + 'lockers/install-filter-options',
      method: 'GET',
    }).then((response: any) => {
      const data = (response && response.data && response.data.data) ? response.data.data : (response && response.data);
      return (data && data.statuses) ? data : { statuses: [], os_versions: [] };
    });
  },

  fetchNetworkHealth(): Promise<Record<number, ILockerNetworkHealth>> {
    return axios({
      url: settings.endpoint + 'lockers/network-health',
      method: 'GET',
    }).then((response: any) => {
      return (response && response.data && response.data.data) ? response.data.data : {};
    });
  },
};
